// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"5626bc6b","239":"86b75e8b","455":"424a0912","977":"bff7d2fe"}[chunkId] + ".chunk.js";
};